import { IsNotEmpty, IsString, IsOptional, IsArray } from 'class-validator';
import { IBaseResponse } from './base-response.dto';
import { IFormField } from './form.dto';

export interface ILayout {
  _id?: string;
  name: string;
  title: string;
  description: string;
  organization: string;
  createdAt?: string;
  updatedAt?: string;
  content: ILayoutContent;
}
export type ILayoutContent = ILayoutFormContent[];
export type ILayoutContentType = 'form'; // TODO add more content types
interface ILayoutContentBase {
  id: string;
  type: ILayoutContentType;
  title: string;
  description: string;
  colSpan: number;
}
export interface ILayoutFormContent extends ILayoutContentBase {
  type: 'form';
  data: IFormField[];
}

/* -------------------------------------------------------------------------- */
/*                               Create new Layout                              */
/* -------------------------------------------------------------------------- */

export class CreateLayoutDto {
  @IsNotEmpty()
  @IsString()
  name: string;
  @IsNotEmpty()
  @IsString()
  title: string;
  @IsString()
  @IsOptional()
  description?: string;
  @IsString()
  @IsOptional()
  organization?: string;
  @IsArray()
  content: ILayoutContent;
}

export interface CreateLayoutResponse extends IBaseResponse {
  layout: ILayout;
}

/* -------------------------------------------------------------------------- */
/*                                   Update Layout                              */
/* -------------------------------------------------------------------------- */

export class UpdateLayoutDto {
  @IsOptional()
  @IsString()
  title: string;
  @IsString()
  @IsOptional()
  description?: string;
  @IsArray()
  @IsOptional()
  content: ILayoutContent;
}

export interface UpdateLayoutResponse extends IBaseResponse {
  id: string;
}

/* -------------------------------------------------------------------------- */
/*                                  Get Layouts                                 */
/* -------------------------------------------------------------------------- */

export type GetLayoutsResponse = ILayout[];
